// extracted by mini-css-extract-plugin
module.exports = {"contactItem":"index_contactItem__DooYq","right":"index_right__8C93O"};